// views/Map/composables/useBounds.js
// But: calculer des bounds paddés (avec sur-élargissement Est si panneau droit ouvert)

export function computePaddedBounds(positions, rightPanelOpen = false, { basePad = 0.15, eastPadWhenPanel = 0.25 } = {}) {
    if (!Array.isArray(positions) || positions.length === 0) return [];
    if (positions.length === 1) {
        const p = positions[0];
        const lat = Number(p.latitude ?? p.lat);
        const lng = Number(p.longitude ?? p.lng);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return [];
        return []; // laisse la carte gérer center/zoom localement si besoin
    }

    let minLat = 90, maxLat = -90, minLng = 180, maxLng = -180;
    for (let i = 0; i < positions.length; i++) {
        const lat = Number(positions[i].latitude ?? positions[i].lat);
        const lng = Number(positions[i].longitude ?? positions[i].lng);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) continue;
        if (lat < minLat) minLat = lat;
        if (lat > maxLat) maxLat = lat;
        if (lng < minLng) minLng = lng;
        if (lng > maxLng) maxLng = lng;
    }
    const latSpan = Math.max(0.001, maxLat - minLat);
    const lngSpan = Math.max(0.001, maxLng - minLng);
    const padLat = latSpan * basePad;
    let padLngW = lngSpan * basePad;
    let padLngE = lngSpan * basePad;
    if (rightPanelOpen) padLngE = lngSpan * eastPadWhenPanel;

    return [
        [minLat - padLat, minLng - padLngW],
        [maxLat + padLat, maxLng + padLngE],
    ];
}
